import { useEffect, useState } from "react";
import { Caravan } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import VehicleCard from "@/components/VehicleCard";

function Pill({ active, children, onClick, testid }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`rounded-full px-5 py-2 text-sm font-medium border transition-all duration-300 ${
        active
          ? "bg-brand border-brand text-white blue-glow"
          : "border-metallic text-slate-400 hover:text-white hover:border-brand/60"
      }`}
    >
      {children}
    </button>
  );
}

export default function Fordon() {
  const [vehicles, setVehicles] = useState(null);
  const [type, setType] = useState("alla");
  const [status, setStatus] = useState("alla");

  useEffect(() => {
    api.get("/vehicles").then((r) => setVehicles(r.data)).catch(() => setVehicles([]));
  }, []);

  const filtered = (vehicles || []).filter(
    (v) => (type === "alla" || v.vtype === type) && (status === "alla" || v.status === status)
  );

  return (
    <main className="pt-28 md:pt-36 pb-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono-brand text-xs md:text-sm tracking-[0.3em] text-electric mb-4">VÅRA FORDON</p>
          <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white">
            Husbilar & <span className="text-gradient-blue">husvagnar</span>
          </h1>
          <p className="mt-4 max-w-xl text-slate-400">
            Alla våra fordon — både tillgängliga och sålda. Hittar du något du gillar? Boka en visning.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col gap-4" data-testid="vehicle-filters">
            <div className="flex flex-wrap gap-2">
              {[
                { v: "alla", l: "Alla" },
                { v: "husbil", l: "Husbilar" },
                { v: "husvagn", l: "Husvagnar" },
              ].map((o) => (
                <Pill key={o.v} testid={`filter-type-${o.v}`} active={type === o.v} onClick={() => setType(o.v)}>
                  {o.l}
                </Pill>
              ))}
            </div>
            <div className="flex flex-wrap gap-2">
              {[
                { v: "alla", l: "Alla statusar" },
                { v: "tillganglig", l: "Tillgängliga" },
                { v: "salt", l: "Sålda" },
              ].map((o) => (
                <Pill key={o.v} testid={`filter-status-${o.v}`} active={status === o.v} onClick={() => setStatus(o.v)}>
                  {o.l}
                </Pill>
              ))}
            </div>
          </div>
        </Reveal>

        {vehicles === null ? (
          <p className="mt-16 text-center text-slate-400" data-testid="vehicles-loading">Laddar fordon...</p>
        ) : filtered.length === 0 ? (
          <div className="mt-16 rounded-2xl border border-dashed border-metallic p-12 text-center" data-testid="vehicles-empty">
            <Caravan className="mx-auto text-slate-600 mb-4" size={40} />
            <p className="text-slate-300 font-display font-bold text-lg">Inga fordon matchar filtret</p>
            <p className="mt-2 text-sm text-slate-500">Testa en annan kombination, eller hör av dig — vi hittar ofta rätt fordon på köpuppdrag.</p>
          </div>
        ) : (
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="vehicles-grid">
            {filtered.map((v, i) => (
              <VehicleCard key={v.id} vehicle={v} index={i} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
